import { clone } from 'lodash';
import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';
import { mapState, } from 'vuex';
import { ICartDisplaySuggestCoupon, ICartSuggestedCoupon } from '~/types/cart';
import { IOfferPrice } from '~/types/catalog';
import { Product } from '~/types/product';

@Component({
    components: {
        couponItem: require('./item').default
    },
    computed: {...mapState('coupons', {couponList: 'coupons'})},
})
export default class OfferComponent extends Vue {

    @prop()
    public price: IOfferPrice;


    public couponList: ICartSuggestedCoupon[];

    get suggestedCoupons() {
        const price = this.price;

        const coupons: ICartDisplaySuggestCoupon[] = [];

        /** @ts-ignore */
        this.couponList.forEach((el: ICartDisplaySuggestCoupon) => {

            const availableOptions = el.variants.filter(
                (e) => (e.suggestType & 2) && !(e.discountTypes && (!price.discount || !(price.discount.type & e.discountTypes))));

            if (!availableOptions.length) {
                return;
            }

            el = clone(el);
            el.primary = availableOptions[0]!;
            el.variants = availableOptions.slice(1).filter((e) => e.value > el.primary.value);

            // здесь у нас ебать приоритеты купонов, чтобы купоны с одинаковым значением не показывались одновременно
            const similarCoupon = coupons.find((e) => e.primary.value === el.primary.value);
            if (similarCoupon && (similarCoupon.priority || el.priority)) {
                if (similarCoupon.priority > el.priority) {
                    return;
                } else {
                    const idx = coupons.indexOf(similarCoupon);
                    if (idx !== -1) {
                        coupons[idx] = el;
                    }
                }
            } else {
                coupons.push(el);
            }
        });

        return coupons;
    }

}
